import { Typography } from '@core/component';
import { HUNDRED } from '@core/constant';
import { useLanguage } from '@core/hook';
import { EActionAttribute, EColor, EIndicator, ETypographyVariant } from '@core/type';
import { ProductBlockEntity } from '@core/type/api';
import { formatNumber } from '@core/util';
import { ProductIndicator } from '@core/widget';

export const TextProductFees = ({
  indicator,
  productType,
}: Pick<ProductBlockEntity, 'indicator' | 'productType'>) => {
  const { language } = useLanguage();
  return (
    <Typography variant={ETypographyVariant.BODY3} color={EColor.SECONDARY}>
      <ProductIndicator indicator={indicator} productType={productType} />
      {indicator.name !== EIndicator.COLLECTIBLE && (
        <Typography variant={ETypographyVariant.BODY3} as={EActionAttribute.SPAN}>
          {' '}
          (
          {formatNumber(language, indicator.percentage / HUNDRED, {
            style: 'percent',
            minimumFractionDigits: 2,
          })}
          )
        </Typography>
      )}
    </Typography>
  );
};
